<template>
  <!-- ALERT ON MOBILE -->
  <v-alert
    v-if="$vuetify.breakpoint.xsOnly && !isSitecoreExperienceEditorOn"
    class="ma-0 maturity-banner"
    :class="this.bannerClassName"
    tile
  >
    <v-row align="center" class="ma-0 pb-4">
      <v-col class="shrink pa-0">
        <v-icon left class="notranslate v-alert__icon theme--light">{{ this.iconName }}</v-icon>
      </v-col>
      <v-col class="grow pa-0">
        <div v-html="bannerTitle" class="banner-title"></div>
      </v-col>
    </v-row>
    <v-row class="ma-0 pb-4">
      <v-col class="grow pa-0">
        <div v-html="bannerContent" class="banner-content"></div>
      </v-col>
    </v-row>
    <v-row class="ma-0 justify-end">
      <v-col class="shrink banner-actions pa-0">
        <sc-link
          class="banner-link v-btn v-btn--tile"
          :field="this.bannerButtonField"
          v-if="
            this.bannerButtonField &&
            this.bannerButtonField.value &&
            this.bannerButtonField.value.href !== ''
          "
        />
      </v-col>
    </v-row>
  </v-alert>
  <!-- ALERT ON OTHER DEVICES -->
  <v-alert
    v-else
    class="ma-0 maturity-banner"
    :class="this.bannerClassName"
    :icon="this.iconName"
    tile
  >
    <v-row align="center">
      <v-col
        class="grow pa-0"
        :class="{
          'banner-desktop-content':
            isSitecoreExperienceEditorOn ||
            (this.bannerButtonField &&
              this.bannerButtonField.value &&
              this.bannerButtonField.value.href !== ''),
        }"
      >
        <div
          v-if="!isSitecoreExperienceEditorOn"
          v-html="bannerTitle"
          class="banner-title pb-3"
        ></div>
        <div v-else class="banner-title pb-3">
          <sc-rich-text :field="this.bannerTitleField" />
        </div>
        <div
          v-if="!isSitecoreExperienceEditorOn"
          v-html="bannerContent"
          class="banner-content pb-0"
        ></div>
        <div v-else class="banner-content pb-0">
          <sc-rich-text :field="this.bannerContentField" />
        </div>
      </v-col>
      <v-col class="shrink banner-actions py-0">
        <sc-link
          class="banner-link v-btn v-btn--tile"
          :field="this.bannerButtonField"
          v-if="
            isSitecoreExperienceEditorOn ||
            (this.bannerButtonField &&
              this.bannerButtonField.value &&
              this.bannerButtonField.value.href !== '')
          "
        />
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import { RichText, Link, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
export default {
  name: 'BaseMaturityBanner',
  data() {
    return {};
  },
  props: {
    maturityBannerContent: {
      type: Object,
      default: () => ({}),
    },
    maturityProductName: {
      type: String,
      default: '',
    },
    maturityAccountNumber: {
      type: String,
      default: '',
    },
    maturityDate: {
      type: String,
      default: '',
    },
    maturityValue: {
      type: String,
      default: '',
    },
    maturityType: {
      type: String,
      default: '',
    },
    maturityNextPaymentDate: {
      type: String,
      default: '',
    },
  },
  computed: {
    bannerClassName() {
      if (
        this.maturityBannerContent &&
        this.maturityBannerContent.fields &&
        this.maturityBannerContent.fields.MaturityType &&
        this.maturityBannerContent.fields.MaturityType.fields &&
        this.maturityBannerContent.fields.MaturityType.fields.MaturityTypeRef &&
        this.maturityBannerContent.fields.MaturityType.fields.MaturityTypeRef.value
      ) {
        return this.maturityBannerContent.fields.MaturityType.fields.MaturityTypeRef.value;
      }
      return '';
    },
    bannerTitleField() {
      if (
        this.maturityBannerContent &&
        this.maturityBannerContent.fields &&
        this.maturityBannerContent.fields.MaturityTitle
      ) {
        return this.maturityBannerContent.fields.MaturityTitle;
      }
      return '';
    },
    bannerContentField() {
      if (
        this.maturityBannerContent &&
        this.maturityBannerContent.fields &&
        this.maturityBannerContent.fields.MaturityContent
      ) {
        return this.maturityBannerContent.fields.MaturityContent;
      }
      return '';
    },
    bannerButtonField() {
      if (
        this.maturityBannerContent &&
        this.maturityBannerContent.fields &&
        this.maturityBannerContent.fields.MaturityButton
      ) {
        return this.maturityBannerContent.fields.MaturityButton;
      }
      return '';
    },
    isInternalLink() {
      if (
        this.bannerButtonField != null &&
        this.bannerButtonField.value != null &&
        this.bannerButtonField.value.linktype === 'internal'
      ) {
        return true;
      } else {
        return false;
      }
    },
    linkLabel() {
      if (
        this.bannerButtonField != null &&
        this.bannerButtonField.value != null &&
        this.bannerButtonField.value.text !== ''
      ) {
        return this.bannerButtonField.value.text;
      } else {
        return '';
      }
    },
    isLink() {
      if (this.isSitecoreExperienceEditorOn) {
        return false;
      }
      if (
        this.bannerButtonField != null &&
        this.bannerButtonField.value != null &&
        this.bannerButtonField.value.href !== ''
      ) {
        return true;
      }

      return false;
    },
    // SC 9 fixed the Href vs URL - now href always come nicely:
    // external: "href": "https://xxx.com.au?testing=test&testing=test",
    // media: "href": "https://xxx.com.au/-/media/iol/data/media/img/alerticon.svg"
    // internal" "href": "/xxx"
    // anchor: "href": "#anchorxxx"
    // email: "href": "mailto:test@test.com.au?subject=xxx",
    // javascript: "href": "javascript:xxx;return false;"
    linkTo() {
      if (typeof this.bannerButtonField.value.href != 'undefined') {
        return this.bannerButtonField.value.href;
      } else {
        return '';
      }
    },
    linkTarget() {
      if (
        this.bannerButtonField != null &&
        this.bannerButtonField.value != null &&
        this.bannerButtonField.value.target === '_blank'
      ) {
        return '_blank';
      } else {
        return '';
      }
    },
    bannerTitle() {
      if (this.bannerTitleField != null && this.bannerTitleField.value != null) {
        return this.replaceBannerTokens(this.bannerTitleField.value);
      } else {
        return '';
      }
    },
    bannerContent() {
      if (this.bannerContentField != null && this.bannerContentField.value != null) {
        return this.replaceBannerTokens(this.bannerContentField.value);
      } else {
        return '';
      }
    },
    iconName() {
      if (
        this.maturityBannerContent &&
        this.maturityBannerContent.fields &&
        this.maturityBannerContent.fields.MaturityIcon &&
        this.maturityBannerContent.fields.MaturityIcon.fields != null &&
        this.maturityBannerContent.fields.MaturityIcon.fields.IconName != null &&
        this.maturityBannerContent.fields.MaturityIcon.fields.IconName.value !== ''
      ) {
        return this.maturityBannerContent.fields.MaturityIcon.fields.IconName.value;
      } else {
        return '';
      }
    },
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
  },
  methods: {
    replaceBannerTokens(content) {
      return content
        .replace('{{product_name}}', this.maturityProductName)
        .replace('{{account_number}}', this.maturityAccountNumber)
        .replace('{{maturity_date}}', this.maturityDate)
        .replace('{{maturity_next_payment_date}}', this.maturityNextPaymentDate)
        .replace(
          '{{maturity_value}}',
          new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(
            this.maturityValue
          )
        );
    },
  },
  components: {
    ScRichText: RichText,
    ScLink: Link,
  },
};
</script>
<style lang="scss" scoped>
.maturity-banner {
  padding: 16px;
  @media #{map-get($display-breakpoints, 'lg-and-up')} {
    padding: 32px 40px !important;
  }
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    padding: 32px;
  }

  &::v-deep {
    .v-icon {
      font-size: 40px;
      height: 40px;
      min-width: 40px;
      margin-right: 40px;
      align-self: center;
      @media #{map-get($display-breakpoints, 'xs-only')} {
        margin-right: 16px;
        font-size: 32px;
        height: 32px;
        min-width: 32px;
      }
    }
    .v-alert__content > .row {
      margin-left: 0px;
    }
    .banner-title p,
    .banner-content p {
      margin-bottom: 0px;
    }
    .banner-title {
      font-size: 18px;
    }
    .banner-content {
      font-size: 18px;
      @media #{map-get($display-breakpoints, 'xs-only')} {
        font-size: 16px;
      }
    }
  }
  .banner-desktop-content {
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      max-width: calc(100% - 190px);
    }
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      max-width: calc(100% - 182px);
    }
  }
  .banner-actions {
    @media #{map-get($display-breakpoints, 'lg-and-up')} {
      padding-left: 40px !important;
    }
    @media #{map-get($display-breakpoints, 'sm-and-up')} {
      padding-left: 32px;
    }
    @media #{map-get($display-breakpoints, 'xs-only')} {
      padding-left: 0px;
      font-size: 16px;
    }
    .v-btn {
      height: 48px;
      min-width: 150px;
    }
  }
  .banner-link {
    padding: 12px;
    font-size: 14px;
  }
}
</style>
